import api from './api';

/**
 * Solicitudes de Clientes
 * Usado por el dashboard del contador (/solicitudes)
 */

export const getSolicitudes = (idCompany, estado) =>
  api.get('/api/solicitudes', {
    params: {
      ...(idCompany && { id_company: idCompany }),
      ...(estado && { estado }),
    },
  }).then(r => r.data);

export const cambiarEstado = (id, estado, notasContador) =>
  api.patch(`/api/solicitudes/${id}/estado`, {
    estado,
    notas_contador: notasContador || null,
  }).then(r => r.data);

export const deleteSolicitud = (id) =>
  api.delete(`/api/solicitudes/${id}`).then(r => r.data);
